import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import Vue from 'vue';
import Vuex from 'vuex';
import Meta from 'vue-meta';
import ClientOnly from 'vue-client-only';
import NoSsr from 'vue-no-ssr';
import { createRouter } from './router.js';
import NuxtChild from './components/nuxt-child.js';
import NuxtError from '../frontend/layouts/error.vue';
import Nuxt from './components/nuxt.js';
import App from './App.js';
import { setContext, getLocation, getRouteData, normalizeError } from './utils';
import { createStore } from './store.js';

/* Plugins */

import nuxt_plugin_sentryserver_4dcef87e from 'nuxt_plugin_sentryserver_4dcef87e'; // Source: ./sentry.server.js (mode: 'server')
import nuxt_plugin_sentryclient_2fd4f214 from 'nuxt_plugin_sentryclient_2fd4f214'; // Source: ./sentry.client.js (mode: 'client')
import nuxt_plugin_plugin_5a19966c from 'nuxt_plugin_plugin_5a19966c'; // Source: ./vuetify/plugin.js (mode: 'all')
import nuxt_plugin_appplugin_7bc277ea from 'nuxt_plugin_appplugin_7bc277ea'; // Source: ../../../node_modules/.pnpm/@nuxt+bridge-edge@3.6.1-29521270.0f9ddce_@azure+identity@4.13.0_@babel+core@7.29.0_@net_669d98f7e0b803d0277d31d0f07005f8/node_modules/@nuxt/bridge-edge/dist/runtime/app.plugin.mjs (mode: 'all')
import nuxt_plugin_configplugin_73a9a765 from 'nuxt_plugin_configplugin_73a9a765'; // Source: ../../../node_modules/.pnpm/@nuxt+bridge-edge@3.6.1-29521270.0f9ddce_@azure+identity@4.13.0_@babel+core@7.29.0_@net_669d98f7e0b803d0277d31d0f07005f8/node_modules/@nuxt/bridge-edge/dist/runtime/config.plugin.mjs (mode: 'all')
import nuxt_plugin_nitrobridgeserver_7919cac0 from 'nuxt_plugin_nitrobridgeserver_7919cac0'; // Source: ./nitro-bridge.server.mjs (mode: 'server')
import nuxt_plugin_nitrobridgeclient_27a50b48 from 'nuxt_plugin_nitrobridgeclient_27a50b48'; // Source: ./nitro-bridge.client.mjs (mode: 'client')
import nuxt_plugin_axios_505692ba from 'nuxt_plugin_axios_505692ba'; // Source: ./axios.js (mode: 'all')
import nuxt_plugin_capiplugin_3bda5999 from 'nuxt_plugin_capiplugin_3bda5999'; // Source: ./capi.plugin.mjs (mode: 'all')
import nuxt_plugin_errorpluginserver_0b136404 from 'nuxt_plugin_errorpluginserver_0b136404'; // Source: ../../../node_modules/.pnpm/@nuxt+bridge-edge@3.6.1-29521270.0f9ddce_@azure+identity@4.13.0_@babel+core@7.29.0_@net_669d98f7e0b803d0277d31d0f07005f8/node_modules/@nuxt/bridge-edge/dist/runtime/error.plugin.server.mjs (mode: 'server')
import nuxt_plugin_initialloading_6bfc895a from 'nuxt_plugin_initialloading_6bfc895a'; // Source: ../frontend/plugins/initial-loading.client (mode: 'client')
import nuxt_plugin_axiosinterceptors_1b48e7d9 from 'nuxt_plugin_axiosinterceptors_1b48e7d9'; // Source: ../frontend/plugins/axios-interceptors (mode: 'all')
import nuxt_plugin_telemetry_61de3f76 from 'nuxt_plugin_telemetry_61de3f76'; // Source: ../frontend/plugins/telemetry (mode: 'all')
import nuxt_plugin_vueToast_17f36235 from 'nuxt_plugin_vueToast_17f36235'; // Source: ../frontend/plugins/vueToast (mode: 'all')
import nuxt_plugin_errorhandler_25db1b11 from 'nuxt_plugin_errorhandler_25db1b11'; // Source: ../frontend/plugins/error-handler (mode: 'all')
import nuxt_plugin_sessionstorage_45745460 from 'nuxt_plugin_sessionstorage_45745460'; // Source: ../frontend/plugins/session-storage (mode: 'all')
import nuxt_plugin_datechangeobserver_9ba01fb0 from 'nuxt_plugin_datechangeobserver_9ba01fb0'; // Source: ../frontend/plugins/date-change-observer (mode: 'all')
import nuxt_plugin_vuexpersistedstate_1c4c3c05 from 'nuxt_plugin_vuexpersistedstate_1c4c3c05'; // Source: ../frontend/plugins/vuex-persistedstate (mode: 'client')
import nuxt_plugin_vuelazyload_e6901296 from 'nuxt_plugin_vuelazyload_e6901296'; // Source: ../frontend/plugins/vue-lazyload (mode: 'client')
import nuxt_plugin_firebase_362e73fb from 'nuxt_plugin_firebase_362e73fb'; // Source: ../frontend/plugins/firebase (mode: 'all')
import nuxt_plugin_sharedComponent_7f90d5a4 from 'nuxt_plugin_sharedComponent_7f90d5a4'; // Source: ../frontend/plugins/sharedComponent (mode: 'all')
import nuxt_plugin_domain_279643b8 from 'nuxt_plugin_domain_279643b8'; // Source: ../frontend/plugins/domain (mode: 'client')
import nuxt_plugin_intersectionobserver_41c8c026 from 'nuxt_plugin_intersectionobserver_41c8c026'; // Source: ../frontend/plugins/intersection-observer (mode: 'client')
import nuxt_plugin_auth_92710cc8 from 'nuxt_plugin_auth_92710cc8'; // Source: ../frontend/plugins/auth (mode: 'all')
import nuxt_plugin_repositories_4c05695c from 'nuxt_plugin_repositories_4c05695c'; // Source: ../frontend/plugins/repositories (mode: 'all')
import nuxt_plugin_refreshloginsessionperiodically_3363dcf4 from 'nuxt_plugin_refreshloginsessionperiodically_3363dcf4'; // Source: ../frontend/plugins/refresh-login-session-periodically (mode: 'all')
import nuxt_plugin_transitionflag_68603720 from 'nuxt_plugin_transitionflag_68603720'; // Source: ../frontend/plugins/transition-flag (mode: 'client')
import nuxt_plugin_onboarding_726c0b0f from 'nuxt_plugin_onboarding_726c0b0f'; // Source: ../frontend/plugins/onboarding (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly);

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, _objectSpread(_objectSpread({}, NoSsr), {}, {
  render: function render(h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true;
      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead');
    }
    return NoSsr.render(h, ctx);
  }
}));

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild);
Vue.component('NChild', NuxtChild);

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt);
Object.defineProperty(Vue.prototype, '$nuxt', {
  get: function get() {
    var globalNuxt = this.$root ? this.$root.$options.$nuxt : null;
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt;
    }
    return globalNuxt;
  },
  configurable: true
});
Vue.use(Meta, {
  "keyName": "head",
  "attribute": "data-n-head",
  "ssrAttribute": "data-n-head-ssr",
  "tagIDKeyName": "hid"
});
var defaultTransition = {
  "name": "page",
  "mode": "out-in",
  "appear": true,
  "appearClass": "appear",
  "appearActiveClass": "appear-active",
  "appearToClass": "appear-to"
};
var originalRegisterModule = Vuex.Store.prototype.registerModule;
function registerModule(path, rawModule) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var preserveState = process.client && (Array.isArray(path) ? !!path.reduce(function (namespacedState, path) {
    return namespacedState && namespacedState[path];
  }, this.state) : path in this.state);
  return originalRegisterModule.call(this, path, rawModule, _objectSpread({
    preserveState: preserveState
  }, options));
}
function createApp(_x) {
  return _createApp.apply(this, arguments);
}
function _createApp() {
  _createApp = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(ssrContext) {
    var config,
      store,
      router,
      app,
      next,
      route,
      path,
      inject,
      _args2 = arguments;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          inject = function _inject(key, value) {
            if (!key) {
              throw new Error('inject(key, value) has no key provided');
            }
            if (value === undefined) {
              throw new Error("inject('".concat(key, "', value) has no value provided"));
            }
            key = '$' + key;
            // Add into app
            app[key] = value;
            // Add into context
            if (!app.context[key]) {
              app.context[key] = value;
            }

            // Add into store
            store[key] = app[key];

            // Check if plugin not already installed
            var installKey = '__nuxt_' + key + '_installed__';
            if (Vue[installKey]) {
              return;
            }
            Vue[installKey] = true;
            // Call Vue.use() to install the plugin into vm
            Vue.use(function () {
              if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
                Object.defineProperty(Vue.prototype, key, {
                  get: function get() {
                    return this.$root.$options[key];
                  }
                });
              }
            });
          };
          config = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {};
          store = createStore(ssrContext);
          _context2.n = 1;
          return createRouter(ssrContext, config, {
            store: store
          });
        case 1:
          router = _context2.v;
          // Add this.$router into store actions/mutations
          store.$router = router;

          // Create Root instance

          // here we inject the router and store to all child components,
          // making them available everywhere as `this.$router` and `this.$store`.
          app = _objectSpread({
            head: {
              "title": undefined,
              "titleTemplate": function titleTemplate(title) {
                return (title ? "".concat(title, " - ") : '') + 'Legalscape';
              },
              "htmlAttrs": {
                "lang": "ja"
              },
              "meta": [{
                "charset": "utf-8"
              }, {
                "name": "viewport",
                "content": "width=device-width, initial-scale=1"
              }, {
                "hid": "description",
                "name": "description",
                "content": "Legal research that sparks joy"
              }],
              "link": [{
                "rel": "icon",
                "type": "image/x-icon",
                "href": "/favicon.ico?v=2"
              }, {
                "rel": "search",
                "type": "application/opensearchdescription+xml",
                "title": "Legalscape",
                "href": "/api/v2/opensearch.xml"
              }],
              "script": [{
                "hid": "gtm-script",
                "innerHTML": "(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':\nnew Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],\nj=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=\n'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);\n})(window,document,'script','dataLayer','GTM-W752NTG');",
                "async": true
              }],
              "noscript": [{
                "hid": "gtm-noscript",
                "innerHTML": "<iframe src=\"https://www.googletagmanager.com/ns.html?id=GTM-W752NTG\" height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\"></iframe>",
                "pbody": true
              }],
              "__dangerouslyDisableSanitizersByTagID": {
                "gtm-script": ["innerHTML"],
                "gtm-noscript": ["innerHTML"]
              },
              "style": []
            },
            store: store,
            router: router,
            nuxt: {
              defaultTransition: defaultTransition,
              transitions: [defaultTransition],
              setTransitions: function setTransitions(transitions) {
                if (!Array.isArray(transitions)) {
                  transitions = [transitions];
                }
                transitions = transitions.map(function (transition) {
                  if (!transition) {
                    transition = defaultTransition;
                  } else if (typeof transition === 'string') {
                    transition = Object.assign({}, defaultTransition, {
                      name: transition
                    });
                  } else {
                    transition = Object.assign({}, defaultTransition, transition);
                  }
                  return transition;
                });
                this.$options.nuxt.transitions = transitions;
                return transitions;
              },
              err: null,
              dateErr: null,
              error: function error(err) {
                err = err || null;
                app.context._errored = Boolean(err);
                err = err ? normalizeError(err) : null;
                var nuxt = app.nuxt; // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
                if (this) {
                  nuxt = this.nuxt || this.$options.nuxt;
                }
                nuxt.dateErr = Date.now();
                nuxt.err = err;
                // Used in src/server.js
                if (ssrContext) {
                  ssrContext.nuxt.error = err;
                }
                return err;
              }
            }
          }, App); // Make app available into store via this.app
          store.app = app;
          next = ssrContext ? ssrContext.next : function (location) {
            return app.router.push(location);
          }; // Resolve route
          if (ssrContext) {
            route = router.resolve(ssrContext.url).route;
          } else {
            path = getLocation(router.options.base, router.options.mode);
            route = router.resolve(path).route;
          }

          // Set context to app.context
          _context2.n = 2;
          return setContext(app, {
            store: store,
            route: route,
            next: next,
            error: app.nuxt.error.bind(app),
            payload: ssrContext ? ssrContext.payload : undefined,
            req: ssrContext ? ssrContext.req : undefined,
            res: ssrContext ? ssrContext.res : undefined,
            beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
            beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
            ssrContext: ssrContext
          });
        case 2:
          // Inject runtime config as $config
          inject('config', config);
          if (process.client) {
            // Replace store state before plugins execution
            if (window.__NUXT__ && window.__NUXT__.state) {
              store.replaceState(window.__NUXT__.state);
            }
          }

          // Add enablePreview(previewData = {}) in context for plugins
          if (process.static && process.client) {
            app.context.enablePreview = function () {
              var previewData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
              app.previewData = Object.assign({}, previewData);
              inject('preview', previewData);
            };
          }
          // Plugin execution
          if (!(process.server && typeof nuxt_plugin_sentryserver_4dcef87e === 'function')) {
            _context2.n = 3;
            break;
          }
          _context2.n = 3;
          return nuxt_plugin_sentryserver_4dcef87e(app.context, inject);
        case 3:
          if (!(process.client && typeof nuxt_plugin_sentryclient_2fd4f214 === 'function')) {
            _context2.n = 4;
            break;
          }
          _context2.n = 4;
          return nuxt_plugin_sentryclient_2fd4f214(app.context, inject);
        case 4:
          if (!(typeof nuxt_plugin_plugin_5a19966c === 'function')) {
            _context2.n = 5;
            break;
          }
          _context2.n = 5;
          return nuxt_plugin_plugin_5a19966c(app.context, inject);
        case 5:
          if (!(typeof nuxt_plugin_appplugin_7bc277ea === 'function')) {
            _context2.n = 6;
            break;
          }
          _context2.n = 6;
          return nuxt_plugin_appplugin_7bc277ea(app.context, inject);
        case 6:
          if (!(typeof nuxt_plugin_configplugin_73a9a765 === 'function')) {
            _context2.n = 7;
            break;
          }
          _context2.n = 7;
          return nuxt_plugin_configplugin_73a9a765(app.context, inject);
        case 7:
          if (!(process.server && typeof nuxt_plugin_nitrobridgeserver_7919cac0 === 'function')) {
            _context2.n = 8;
            break;
          }
          _context2.n = 8;
          return nuxt_plugin_nitrobridgeserver_7919cac0(app.context, inject);
        case 8:
          if (!(process.client && typeof nuxt_plugin_nitrobridgeclient_27a50b48 === 'function')) {
            _context2.n = 9;
            break;
          }
          _context2.n = 9;
          return nuxt_plugin_nitrobridgeclient_27a50b48(app.context, inject);
        case 9:
          if (!(typeof nuxt_plugin_axios_505692ba === 'function')) {
            _context2.n = 10;
            break;
          }
          _context2.n = 10;
          return nuxt_plugin_axios_505692ba(app.context, inject);
        case 10:
          if (!(typeof nuxt_plugin_capiplugin_3bda5999 === 'function')) {
            _context2.n = 11;
            break;
          }
          _context2.n = 11;
          return nuxt_plugin_capiplugin_3bda5999(app.context, inject);
        case 11:
          if (!(process.server && typeof nuxt_plugin_errorpluginserver_0b136404 === 'function')) {
            _context2.n = 12;
            break;
          }
          _context2.n = 12;
          return nuxt_plugin_errorpluginserver_0b136404(app.context, inject);
        case 12:
          if (!(process.client && typeof nuxt_plugin_initialloading_6bfc895a === 'function')) {
            _context2.n = 13;
            break;
          }
          _context2.n = 13;
          return nuxt_plugin_initialloading_6bfc895a(app.context, inject);
        case 13:
          if (!(typeof nuxt_plugin_axiosinterceptors_1b48e7d9 === 'function')) {
            _context2.n = 14;
            break;
          }
          _context2.n = 14;
          return nuxt_plugin_axiosinterceptors_1b48e7d9(app.context, inject);
        case 14:
          if (!(typeof nuxt_plugin_telemetry_61de3f76 === 'function')) {
            _context2.n = 15;
            break;
          }
          _context2.n = 15;
          return nuxt_plugin_telemetry_61de3f76(app.context, inject);
        case 15:
          if (!(typeof nuxt_plugin_vueToast_17f36235 === 'function')) {
            _context2.n = 16;
            break;
          }
          _context2.n = 16;
          return nuxt_plugin_vueToast_17f36235(app.context, inject);
        case 16:
          if (!(typeof nuxt_plugin_errorhandler_25db1b11 === 'function')) {
            _context2.n = 17;
            break;
          }
          _context2.n = 17;
          return nuxt_plugin_errorhandler_25db1b11(app.context, inject);
        case 17:
          if (!(typeof nuxt_plugin_sessionstorage_45745460 === 'function')) {
            _context2.n = 18;
            break;
          }
          _context2.n = 18;
          return nuxt_plugin_sessionstorage_45745460(app.context, inject);
        case 18:
          if (!(typeof nuxt_plugin_datechangeobserver_9ba01fb0 === 'function')) {
            _context2.n = 19;
            break;
          }
          _context2.n = 19;
          return nuxt_plugin_datechangeobserver_9ba01fb0(app.context, inject);
        case 19:
          if (!(process.client && typeof nuxt_plugin_vuexpersistedstate_1c4c3c05 === 'function')) {
            _context2.n = 20;
            break;
          }
          _context2.n = 20;
          return nuxt_plugin_vuexpersistedstate_1c4c3c05(app.context, inject);
        case 20:
          if (!(process.client && typeof nuxt_plugin_vuelazyload_e6901296 === 'function')) {
            _context2.n = 21;
            break;
          }
          _context2.n = 21;
          return nuxt_plugin_vuelazyload_e6901296(app.context, inject);
        case 21:
          if (!(typeof nuxt_plugin_firebase_362e73fb === 'function')) {
            _context2.n = 22;
            break;
          }
          _context2.n = 22;
          return nuxt_plugin_firebase_362e73fb(app.context, inject);
        case 22:
          if (!(typeof nuxt_plugin_sharedComponent_7f90d5a4 === 'function')) {
            _context2.n = 23;
            break;
          }
          _context2.n = 23;
          return nuxt_plugin_sharedComponent_7f90d5a4(app.context, inject);
        case 23:
          if (!(process.client && typeof nuxt_plugin_domain_279643b8 === 'function')) {
            _context2.n = 24;
            break;
          }
          _context2.n = 24;
          return nuxt_plugin_domain_279643b8(app.context, inject);
        case 24:
          if (!(process.client && typeof nuxt_plugin_intersectionobserver_41c8c026 === 'function')) {
            _context2.n = 25;
            break;
          }
          _context2.n = 25;
          return nuxt_plugin_intersectionobserver_41c8c026(app.context, inject);
        case 25:
          if (!(typeof nuxt_plugin_auth_92710cc8 === 'function')) {
            _context2.n = 26;
            break;
          }
          _context2.n = 26;
          return nuxt_plugin_auth_92710cc8(app.context, inject);
        case 26:
          if (!(typeof nuxt_plugin_repositories_4c05695c === 'function')) {
            _context2.n = 27;
            break;
          }
          _context2.n = 27;
          return nuxt_plugin_repositories_4c05695c(app.context, inject);
        case 27:
          if (!(typeof nuxt_plugin_refreshloginsessionperiodically_3363dcf4 === 'function')) {
            _context2.n = 28;
            break;
          }
          _context2.n = 28;
          return nuxt_plugin_refreshloginsessionperiodically_3363dcf4(app.context, inject);
        case 28:
          if (!(process.client && typeof nuxt_plugin_transitionflag_68603720 === 'function')) {
            _context2.n = 29;
            break;
          }
          _context2.n = 29;
          return nuxt_plugin_transitionflag_68603720(app.context, inject);
        case 29:
          if (!(typeof nuxt_plugin_onboarding_726c0b0f === 'function')) {
            _context2.n = 30;
            break;
          }
          _context2.n = 30;
          return nuxt_plugin_onboarding_726c0b0f(app.context, inject);
        case 30:
          // Lock enablePreview in context
          if (process.static && process.client) {
            app.context.enablePreview = function () {
              console.warn('You cannot call enablePreview() outside a plugin.');
            };
          }

          // Wait for async component to be resolved first
          _context2.n = 31;
          return new Promise(function (resolve, reject) {
            // Ignore 404s rather than blindly replacing URL in browser
            if (process.client) {
              var _router$resolve = router.resolve(app.context.route.fullPath),
                _route = _router$resolve.route;
              if (!_route.matched.length) {
                return resolve();
              }
            }
            router.replace(app.context.route.fullPath, resolve, function (err) {
              // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
              if (!err._isRouter) return reject(err);
              if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve();

              // navigated to a different route in router guard
              var unregister = router.afterEach(/*#__PURE__*/function () {
                var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(to, from) {
                  return _regenerator().w(function (_context) {
                    while (1) switch (_context.n) {
                      case 0:
                        if (process.server && ssrContext && ssrContext.url) {
                          ssrContext.url = to.fullPath;
                        }
                        _context.n = 1;
                        return getRouteData(to);
                      case 1:
                        app.context.route = _context.v;
                        app.context.params = to.params || {};
                        app.context.query = to.query || {};
                        unregister();
                        resolve();
                      case 2:
                        return _context.a(2);
                    }
                  }, _callee);
                }));
                return function (_x2, _x3) {
                  return _ref.apply(this, arguments);
                };
              }());
            });
          });
        case 31:
          return _context2.a(2, {
            store: store,
            app: app,
            router: router
          });
      }
    }, _callee2);
  }));
  return _createApp.apply(this, arguments);
}
export { createApp, NuxtError };